const service = {
    _cache: [],
    _sid: null,
    _fetching_sid: false,
    _init: false,

    get_endpoint: function() {
        if (window.location.host.endsWith(".localhost"))
            return 'http://fastlane.autohaus-wolfsburg.localhost/api/interaction-events';
        if (window.location.host.startsWith("staging."))
            return 'https://staging.fastlane.autohaus-wolfsburg.de/api/interaction-events';
        return 'https://fastlane.autohaus-wolfsburg.de/api/interaction-events';
    },

    get_sid: async function() {
        if (this._sid || this._fetching_sid) return;
        this._fetching_sid = true;

        const sid =
            window.localStorage.getItem('fastlane-service-id') ??
            (await (await fetch( `${this.get_endpoint()}/generateServiceId`, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json',
                    "Content-Type": "application/json",
                },
            } )).json())?.serviceId;

        this._fetching_sid = false;
        if (sid) {
            this._sid = sid;
            window.localStorage.setItem('fastlane-service-id', sid);
            this._cache.forEach( async ([event, assoc, data]) => await this.push(event, assoc, data) );
            this._cache = [];
        }
    },

    push: async function(event, assoc, data) {
        if (!this._sid) {
            this._cache.push([event, assoc, data]);
            await this.get_sid();
        } else await fetch( `${this.get_endpoint()}/handle`, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({
                serviceId: this._sid,
                priceOfferAssociationId: assoc,
                eventName: event,
                data
            }),
            headers: {
                "Accept": 'application/json',
                "Content-Type": "application/json",
            },
        } )
    },

    init: async function () {
        if (this._init) return;
        if (document.readyState === 'loading') return;
        this._init = true;

        const uuid = crypto.randomUUID();
        const assoc = document
            .querySelector('[data-fastlane-poa-id]')
            ?.dataset?.fastlanePoaId;

        if (uuid && assoc) {
            await this.push('load', assoc, {element: uuid});
            window.setInterval(
                () => this.push('idle', assoc, {element: uuid}),
                30000
            );
            document.querySelectorAll('[data-fastlane-click]')
                .forEach(e =>
                    e.addEventListener('click', () =>
                        this.push( 'click', assoc, {element: e.dataset.fastlaneClick} )
                    )
                )
            document.querySelectorAll('[data-fastlane-fill]')
                .forEach(e =>
                    e.addEventListener('focus', () =>
                        this.push( 'fill', assoc, {element: e.dataset.fastlaneFill} )
                    )
                )
            document.querySelectorAll('[data-fastlane-submit]')
                .forEach(button => {
                    const form = button.closest('form');
                    if (form.dataset.fastlaneProcessed === '1') return;

                    form.addEventListener('submit', e => {
                        e.preventDefault();
                        this.push( 'submit', assoc, {element: button.dataset.fastlaneSubmit} )
                        window.setTimeout(() => form.submit(), 150);
                    });

                    form.dataset.fastlaneProcessed = '1';
                })
        }
    }
}

document.addEventListener('readystatechange', () => service.init());
service.init();
